import { useEffect, useState } from 'react';
import { useEditor, useNode } from '@craftjs/core';
import MuiButton from '@mui/material/Button';
import ContentEditable from 'react-contenteditable';
import useResponsiveValues from '@/components/editor/hooks/useResponsiveValues';
import ButtonBlockSettings from '@/components/editor/settings/ButtonSettings/ButtonBlockSettings';
import useNormalizeButtonSettings from '@/components/editor/settings/ButtonSettings/useNormalizeButtonSettings';
import { CssClass } from '@/components/editor/settings/ClassSettings';
import { useNavigate } from 'react-router-dom';
import { ButtonProps, ButtonTarget } from '../settings/ButtonSettings/ButtonSettings';
import useVariableValues from '../hooks/useVariableValues';

type Props = CssClass & ButtonProps;

const ButtonBlock = (props: Partial<Props>) => {
  const {
    id,
    connectors: { connect, drag },
    actions: { setProp },
    hasSelectedNode,
  } = useNode((state) => {
    return {
      hasSelectedNode: state.events.selected,
      hasDraggedNode: state.events.dragged,
    };
  });

  const { query } = useEditor();
  const responsive = useResponsiveValues();
  const [editable, setEditable] = useState(false);
  const buttonProps = useNormalizeButtonSettings(props);
  const vv = useVariableValues();
  const isEditorEnabled = query.getOptions().enabled;
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (isEditorEnabled) return;
    if (props?.url && typeof props?.url === 'string') {
      if (responsive.getValue(props?.target) === ButtonTarget.BLANK) {
        window.open(vv.getValue(props?.url ?? ''),'_blank')
      } else {
        navigate(vv.getValue(props?.url ?? ''));
      }
    }
  };

  useEffect(() => {
    !hasSelectedNode && setEditable(false);
  }, [hasSelectedNode]);

  return (
    <MuiButton
      key={`${id}-${responsive.viewport}`}
      ref={(ref: any) => connect(drag(ref))}
      {...buttonProps}
      onClick={handleClick}
    >
      <ContentEditable
        className={`text-block ${responsive.getValue(props?.cssClass)}`}
        html={buttonProps?.text}
        onChange={(e) => {
          setProp(
            (props: Props) =>
              (props.text = e.target.value.replace(/<\/?[^>]+(>|$)/g, ''))
          );
        }}
        disabled={!isEditorEnabled || !editable}
        onClick={(_) => setEditable(true)}
      />
    </MuiButton>
  );
};

ButtonBlock.craft = {
  displayName: 'Botón',
  props: {
    text: 'Reemplaza',
    href: 'Test',
  },
  related: {
    settings: ButtonBlockSettings,
  },
};

export default ButtonBlock;
